<app-page-header title="Home" active_item="Saque Boleto" titleLink="/reports" ></app-page-header>
<div class="loading-transferencia" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.boletoPayment' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.paymentData' | translate }}</div>
      </div>
      <div class="card-body">
        <div class="alert alert-dark text-center" role="alert">
          <b
            > {{ 'common.availableBalance' | translate }}: 
            {{
              saldoDisponivel
                | formatCurrency 
            }}</b
          >
        </div>
        <form [formGroup]="saque">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtChavePix" class="form-label"
                  >{{ 'common.barcode' | translate }} <span class="text-danger">*</span></label
                >
                <div class="input-icon-container">

                  <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  id="txtChavePix"
                  *ngIf="saque.controls.tipoChave.value === ''"
                  [ngClass]="{
                    'is-invalid state-invalid':
                    saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="false"
                  />
                  
                  <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'EVP'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                    saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                  />
                  <i (click)="paste()" class="fe fe-clipboard input-icon btn-color"></i>
                </div>
                <div class="invalid-feedback">{{ chavePixFeedBack }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-5 col-lg-6 col-sm-6">
                <!-- <div class="form-group">
                  <label for="txtDocumentoRecebedor" class="form-label">
                    {{ 'common.recipientDocument' | translate }} <span class="text-danger">*</span>
                  </label>
                  <input
                    mask="CPF_CNPJ"
                    [formControl]="saque.controls.documentoRecebedor"
                    class="form-control"
                    type="text"
                    name="documentoRecebedor"
                    id="txtDocumentoRecebedor"
                    [ngClass]="{
                      'is-invalid state-invalid':
                        saque.controls.documentoRecebedor.invalid && isSubmitted
                    }"
                  />
                  <div class="invalid-feedback">{{ documentoFeedBack }}</div>
                </div> -->
              </div>              
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  >{{ 'common.boletoValue' | translate }} <span class="text-danger">*</span></label
                >
                <input
                  [placeholder]="placeholderValue"
                  [formControl]="saque.controls.valorSolicitado"
                  currencyMask
                  [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                  class="form-control"
                  type="text"
                  name="valorSolicitado"
                  id="txtValorSolicitado"
                  (focusout)="valorSolicitadoChanged()"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.valorSolicitado.invalid && isSubmitted
                  }"
                />
                <label for="txtValorSolicitado" class="txtAviso"
                  >{{ 'common.equalToBoletoCodeValue' | translate }}</label
                >
                <div class="invalid-feedback">{{ valorFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">{{ 'common.fee' | translate }}</label>
                <input
                  [prefix]="( '' | currencySymbol ) + ' '"
                  [formControl]="saque.controls.taxa"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control bg-tertiary"
                  type="text"
                  name="taxa"
                  id="txtTaxa"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label"
                  >{{ 'common.totalAmount' | translate }}</label
                >
                <input
                  [prefix]="( '' | currencySymbol ) + ' '"
                  [formControl]="saque.controls.valorTotal"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control bg-tertiary"
                  type="text"
                  name="valorTotal"
                  id="txtValorTotal"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="makeWithdraw()"
              >
                <i class="fe fe-arrow-up-right"></i>{{ 'common.pay' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'common.informAuthToken' | translate }}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      {{ 'common.validateButton' | translate }}
    </button>
  </div>
</ng-template>
